const INFLUENCER_TYPE_OPTIONS_API = [
  { value: 'celebrity', label: 'Celebrity' },
  { value: 'earlyStage', label: 'Early Stage' },
  { value: 'functional', label: 'Functional' },
  { value: 'industry', label: 'Industry' },
  { value: 'investor', label: 'Investor' },
  { value: 'other', label: 'Other' },
];

export { INFLUENCER_TYPE_OPTIONS_API };
